import { LoadingStates } from '@pb/utils'

import { DIGITAL_RETURNS_SESSION_ID_KEY } from '../helpers/constants'
import { ReturnsState, OrderStatus, SubmittedReturnsInfo } from '../types'

const initialState: ReturnsState = {
  labelsStatus: LoadingStates.NotLoaded,
  returnsLoginFormStatus: LoadingStates.NotLoaded,
  orderId: '',
  email: '',
  consignments: [],
  orderItemsStatus: LoadingStates.NotLoaded,
  customerInfo: {
    email: '',
    phone: '',
    customerBpid: '',
    address: {
      firstName: '',
      lastName: '',
      line1: '',
      line2: '',
      city: '',
      postalCode: '',
      countryIsoCode: '',
      country: '',
    },
  },
  orderInfo: {
    createdAt: '',
  },
  currency: '',
  orderStatus: '' as OrderStatus,
  submitReturnsInfoStatus: LoadingStates.NotLoaded,
  submittedReturnsInfo: {} as SubmittedReturnsInfo,
  returnsReasonsStatus: LoadingStates.NotLoaded,
  isAuthenticated: Boolean(sessionStorage.getItem(DIGITAL_RETURNS_SESSION_ID_KEY)),
}
export default initialState
